import { type ComponentProps, forwardRef, type ReactNode } from 'react';

import { tailwindVariants, type VariantProps } from '@air/utils-tailwind';

export const cardAction = tailwindVariants({
  base: 'pointer-events-auto flex h-6 min-w-[24px] items-center justify-center gap-1 rounded-4 px-1',
  variants: {
    color: {
      light:
        'ads:bg-subtle bg-pigeon-100 ads:text-primary text-pigeon-700 ads:hover:bg-hover-subtle hover:bg-pigeon-200 ads:hover:text-primary hover:text-pigeon-700 ads:focus-visible:bg-hover-subtle focus-visible:bg-pigeon-200 ads:focus-visible:text-primary focus-visible:text-pigeon-700 active:bg-pigeon-200 ads:active:bg-hover-subtle active:text-pigeon-700 ads:active:text-primary',
      dark: 'bg-black/70 text-white hover:bg-black hover:text-white focus-visible:bg-black focus-visible:text-white active:bg-black active:text-white',
    },
  },
  defaultVariants: {
    color: 'dark',
  },
});

type CardIconVariants = VariantProps<typeof cardAction>;

export type CardActionProps = CardIconVariants &
  ComponentProps<'button'> & {
    icon: ReactNode;
    text?: string | number;
  };

export const CardAction = forwardRef<HTMLButtonElement, CardActionProps>(
  ({ icon, text, color, className, ...rest }, ref) => {
    return (
      <button {...rest} ref={ref} className={cardAction({ color, class: className })}>
        {icon}
        {!!text && <span className="text-12 text-inherit uppercase">{text}</span>}
      </button>
    );
  },
);

CardAction.displayName = 'CardAction  ';
